export default class MobileMenu {
  constructor() {
    // Základní elementy
    this.toggleButton = document.getElementById("mobile-nav-toggle");
    this.body = document.body;
    this.nav = document.querySelector(".header__nav");

    // Pokud nenajdeme toggle button, není třeba pokračovat
    if (!this.toggleButton) return;

    // Inicializace
    this.isOpen = false;
    this.init();
  }

  init() {
    // Přidání click event listeneru pro hamburger
    this.toggleButton.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleMenu();
    });

    // Submenu toggles - event delegation
    this.nav.addEventListener("click", (e) => {
      const toggleBtn = e.target.closest(".toggle-submenu");
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();

        const parentItem = toggleBtn.closest(".header__item--parent");
        if (parentItem) {
          // Jednoduchý toggle
          parentItem.classList.toggle("submenu-open");
        }
      }
    });

    // Zavřít menu při kliknutí na overlay (mimo menu a hamburger)
    document.addEventListener("click", (e) => {
      if (
        this.isOpen &&
        !e.target.closest(".header__nav") &&
        !e.target.closest(".header__hamburger")
      ) {
        this.toggleMenu();
      }
    });

    // Zavřít menu při stisknutí Escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.toggleMenu();
      }
    });
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;

    // Přepnutí aria-expanded atributu
    this.toggleButton.setAttribute("aria-expanded", this.isOpen);

    // Přidání/odebrání třídy pro otevřené menu
    this.body.classList.toggle("menu-is-open");

    // Při zavření menu zavřít i všechny submenu
    if (!this.isOpen) {
      document.querySelectorAll(".submenu-open").forEach((item) => {
        item.classList.remove("submenu-open");
      });
    }
  }
}
